// This file configures the initialization of Sentry on the client.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"537eafffb0da81b05a82d5b0a776e6d13aec2980"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.2.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/login-redirect\"},{\"path\":\"/redirect\"},{\"path\":\"/air-request\"},{\"path\":\"/calendar\"},{\"path\":\"/client-detail\"},{\"path\":\"/client-detail/cards\"},{\"path\":\"/client-detail/edit-main\"},{\"path\":\"/clients\"},{\"path\":\"/clients/create\"},{\"path\":\"/dashboard\"},{\"path\":\"/gallery\"},{\"path\":\"/marketing/website\"},{\"path\":\"/search\"},{\"path\":\"/search-details\"},{\"path\":\"/settings\"},{\"path\":\"/stories\"},{\"path\":\"/user-management\"},{\"path\":\"/update/data/credit-card\"},{\"path\":\"/update/data/profile\"},{\"path\":\"/back-to-admin\"},{\"path\":\"/back-to-superadmin\"},{\"path\":\"/crm-logout\"},{\"path\":\"/impersonate/leave\"}]}";import * as Sentry from '@sentry/nextjs';
import { SENTRY_DSN } from '@/consts/sentry';
import { isStaleChunkSentryEvent } from '@/hooks/useStaleChunkRecovery';

const isDevelopment = process.env.NODE_ENV === 'development';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,
  enabled: Boolean(SENTRY_DSN),
  tracesSampleRate: isDevelopment ? 1 : 0.2,
  debug: isDevelopment,
  beforeSend: (event, hint) => {
    const error = hint?.originalException;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
    const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
    const fromStaticChunk = frames.some(
      (frame) => typeof frame.filename === 'string' && frame.filename.includes('/_next/static/')
    );

    if (fromStaticChunk || isStaleChunkSentryEvent(message)) {
      return null;
    }

    return event;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
